export default function FareDetails({ pricingDetail: fare }) {
  const fareBreakdowns = fare.FareBreakDowns;
  return (
    <>
      {fareBreakdowns && fareBreakdowns.length > 0 && fareBreakdowns.map((fare) => (
        <>
          <tr className="bg-slate-200">
            <td colSpan={4}>
              <h2 className="font-bold text-lg py-1">{fare.Passenger.Code} - {fare.Passenger.QTY}</h2>
            </td>
          </tr>
          {fareBreakdowns.length > 1 && <>
            <tr>
              <th>Base Fare</th>
              <td>{fare.Currency} {fare.SubTotFare}</td>
            </tr>
            <tr>
              {fare.SubTotTax > 0 && <>
                <th>Total Tax</th>
                <td>{fare.Currency} {fare.SubTotTax}</td>
              </>}
            </tr>
          </>}


          {fare.Baggages && <tr>
            <th>Baggages</th>
            <td>
              {fare.Baggages.map((baggage, index) => (
                <div key={index}>
                  {baggage.Quantity} {baggage.Unit} - {baggage.BagType}
                </div>
              ))}
            </td>
          </tr>}
          <tr>
            <td colSpan={4} className="min-h-5"><span className="invisible">sr-only</span></td></tr>

        </>
      ))}
      <tr className="bg-slate-200">
        <td colSpan={4}>
          <h2 className="font-bold text-lg py-1">Fare Summary</h2>
        </td>
      </tr>
      <tr>
        <th>Total Base Fare</th>
        <td>{fare.Currency} {fare.GTotalBaseFare}</td>
        <th>Non-Refundable</th>
        <td>{fare.NonRefundable ? "Yes" : "No"}</td>
      </tr>
      <tr>
        {fare.GTotalTax > 0 && <>
          <th>Total Tax</th>
          <td>{fare.Currency} {fare.GTotalTax}</td>
        </>}
      </tr>
      <tr>
        {fare.Discount > 0 &&
          <>
            <th>Discount</th>
            <td>{fare.Currency} {fare.Discount}</td>
          </>
        }
      </tr>
      <tr>
        {fare.Charges > 0 &&
          <>
            <th>Charges</th>
            <td>{fare.Currency} {fare.Charges}</td>
          </>
        }
      </tr>
      <tr>
        <th>Total Fare</th>
        <td>{fare.Currency} {fare.GTotalFare}</td>
      </tr>
      <tr>
        <td colSpan={4} className="min-h-5"><span className="invisible">sr-only</span></td>
      </tr>
    </>
  );
}
